<template>
  <div v-if="history">
    <div class="a-tab__title-block admin__a-tab admin__a-tab">
      <h3>История изменения заявки по редактированию</h3>
    </div>
   <div class="admin__a-tab-content admin__a-tab-content--show">
     <div class="a-ui-tab u-margin-b-24">
       <div class="a-ui-tab__block">
         <div class="a-ui-tab__content-block">
           <section v-maximizable>
             <div class="table-tab">
             <div class="table-tab__container">
               <table class="table-tab__block table ">
                 <thead class="table-tab__thead table-tab__border-bottom">
                   <tr class="">
                     <th></th>
                     <th>Объект</th>
                     <th>Поле</th>
                     <th>Дата</th>
                     <th>ФИО</th>
                     <th>Операция</th>
                     <th>Было</th>
                     <th>Стало</th>
                   </tr>
                 </thead>

                 <tbody>
                  <tr v-for="(item, idx) of history">
                    <th>
                      {{idx + 1}}
                    </th>
                    <th>
                      {{item.subject}}
                    </th>
                    <th>
                      {{$t(item.field.label)}}
                    </th>
                    <th>
                      <date-time :value="item.time" tag="span"></date-time>
                    </th>
                    <th>
                      {{item.user | fullName}}
                    </th>
                    <th>
                      {{$t(item.type.label)}}
                    </th>
                    <th>
                      {{$t(item.value.old)}}
                    </th>
                    <th>
                      {{$t(item.value.new)}}
                    </th>
                  </tr>
                 </tbody>
               </table>
             </div>
           </div>
           </section>
         </div>
       </div>
     </div>
   </div>
  </div>
</template>

<script>
  export default {
    props: {
      request: {
        type: Object,
        required: true
      },

      bid: {
        type: Object
      }
    },

    computed: {
      records() {
        let bidNum = 0;

        if (this.bid) {
          bidNum = this.bid.num;
        }

        return _.orderBy(_.filter(this.request.userChangesHistory, { bidNum }), ['time', 'serial'])
      },

      history() {
        return _.map(this.records, e => {
          let subject = [];
          let request = this.request;
          let bid = this.bid;

          if (e.position) {
            const position = _.find(bid.specs, { position: e.position });

            if (position) {
              subject.push(`Спецификация, Номенклатура ${position.serial} с описанием "${e.name}"`);
            }
            else if (e.type.DELETE) {
              subject.push(`Спецификация, Необязательная номенклатура с описанием "${e.name}"`);
            }
          }

          if (e.document) {
            const doc = _.find(_.get((bid || request), 'documents', { document: e.document}));
            subject.push(`Документ "${doc.name}"`);

            if (e.name) {
              subject.push(`Файл "${e.name}"`);
            }
          }

          if (e.criterion) {
            let criterion;

            for (const group in bid.criteria) {
              criterion = _.find(bid.criteria[group], { num: e.criterion });
              if (criterion) break;
            }

            if (criterion) {
              subject.push(`Критерий "${criterion.criterionName}"`);
            }
            else {
              subject.push(`Критерий`);
            }

            if (e.object.FILE) {
              subject.push(`Файл "${e.name}"`);
            }
          }

          if (e.part) {
            subject.push(`График платежей, Партия ${e.part}`);
          }

          if (e.payNum) {
            const part = _.find(bid.parts, { part: e.part });
            const payment = _.find(part.payments, { num: e.payNum, payType: e.payType });

            let paymentType;
            let paymentComment;

            if (payment.type === 'contract') {
              paymentType = 'form.lot.payments.prepayment';
              paymentComment = 'form.lot.payments.from-date-of-contract-conclusion';
            }
            else if (payment.type === 'delivery') {
              paymentType = 'form.lot.payments.payment';
              paymentComment = 'form.lot.payments.from-date-of-delivery-of-part';
            }
            else if (payment.type === 'accept') {
              paymentType = 'form.lot.payments.payment';
              paymentComment = 'form.lot.payments.from-date-of-quality-accepting';
            }

            subject.push(`${this.$t(paymentType)} №${payment.num} ${this.$t(paymentComment)}`)
          }

          let converter = e => e;

          if (e.field.PERCENT || e.field.PRC) {
            converter = this.$options.filters.percent;
          }
          else if (e.field.PRICE) {
            converter = this.$options.filters.price;
          }
          else if (e.field.DISMISS) {
            converter = v => {
              return !!v ? 'Да': 'Нет'
            }
          }
          else if (e.field.CURRENCY_CLAUSE) {
            converter = v => {
              return !!v ? 'Применима': 'Не применима'
            }
          }
          else if (e.field.BID_CURRENCY || e.field.PAY_CURRENCY) {
            converter = v => {
              return (new this.enums.Currency(v)).label
            }
          }

          return {
            ...e,
            subject: subject.join(', '),
            value: {
              old: converter(e.value.old),
              new: converter(e.value.new)
            },
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
